export const FOOTER_SECTIONS = Object.freeze({
  PRODUCTS: 'products',
  INFO_CENTER: 'info_center',
  SHOPPING: 'shopping',
  ABOUT_COMPANY: 'about_company',
});

export const FOOTER_SECTIONS_OPTIONS = Object.freeze([
  { text: 'Produkty', value: FOOTER_SECTIONS.PRODUCTS },
  { text: 'Centrum informacji', value: FOOTER_SECTIONS.INFO_CENTER },
  { text: 'Zakupy', value: FOOTER_SECTIONS.SHOPPING },
  { text: 'O firmie', value: FOOTER_SECTIONS.ABOUT_COMPANY },
]);

export const FOOTER_SECTIONS_VALUES = Object.freeze([
  FOOTER_SECTIONS.PRODUCTS,
  FOOTER_SECTIONS.INFO_CENTER,
  FOOTER_SECTIONS.SHOPPING,
  FOOTER_SECTIONS.ABOUT_COMPANY,
]);
